import { Link } from 'react-router-dom';
import ShowDeviceModal from './Modal/ShowDeviceModal';
import MenuItem from '@mui/material/MenuItem';
import RemovePlanModal from './Modal/RemovePlanModal';
import 'reactjs-popup/dist/index.css';
import ic_left_arrow from '../../../assets/images/ic_left_arrow.svg';
import DeviceListZonePlane from './DeviceListZonePlane';
import { permissionObj } from '../../../Helpers/permission';
import { Box } from '@mui/material';
import noData from '../../../assets/images/warning.svg';
import ZoneMapSelect from '../../../components/ZoneMapSelect';
import { ClearGetListZoneMap } from '../../../reduxToolkit/EmployeeZones/EmployeeZoneSlice';
import ShowImg from './ShowDevicesImg';
import {InfoIcon, MapSolidIcon, TrashOutlineIcon,} from '../../../components/buttons/IconButtons';
import {ShowDevicesApp} from "./Funtionality/ShowDevicesApp";
import {CustomSelectAndChildren} from "../../../components/CustomSelectAndChildren";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import routes from "../../../Routes/routes";
import ButtonAction from '../../../components/buttons/ButtonAction';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 * @returns {JSX.Element}
 * @constructor
 */

const ShowDevices = () => {


    const { openNavigation,
        setOpenNavigation,
        zoneDetailFatherAndChild,
        viewPlane,
        setDeletePlaneModal,
        getListZoneMap,
        setShowPlaneModal,
        setIsDeviceList,
        isDeviceList,
        getZoneDevicesLists,
        selectedZone,
        showPlaneModal,
        setProfileImage,
        deletePlaneModal,
        handleChange,
        t,
        dispatch,
        DEV,
        permission,
        x,y ,id
    } = ShowDevicesApp();

    return (
        <>
            <div className='container_fluid show_device'>
                <div className='Image_container_zone'>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div className={`show_device_navigation ${openNavigation ? 'h43' : ''}`}>
                                <div className='show_device_navigation_item pb-2'>
                                    <Link
                                        to={routes.zone.details + id}
                                        onClick={() => dispatch(ClearGetListZoneMap())}
                                    >
                                        <img
                                            className={"w-20px m-2px"}
                                            src={ic_left_arrow}
                                            alt='image'
                                        />
                                    </Link>
                                    <h4 className='ml-2' >
                                        {t('zone_information')}
                                    </h4>
                                    <div onClick={() => setOpenNavigation(!openNavigation)}>
                                        <ArrowDropDownIcon className={`ml-1 arrow-icon ${openNavigation ? 'open' : ''}`} />
                                    </div>
                                </div>
                                <div>
                                    <h6>{t('zone')}</h6>
                                    <p>{zoneDetailFatherAndChild?.name}</p>
                                </div>
                                <div className={"mt-3"}>
                                    <CustomSelectAndChildren
                                        id={"slt_sd_viewplane"}
                                        name={"template"}
                                        value={viewPlane} // Current selected template value
                                        keyName="id" // Key name for the option's value
                                        onChange={handleChange} // Function to handle template change
                                        trans={"view"} // Translation key for the label
                                        label={"lbl_sd_view"} // Label for the select dropdown
                                        showNoSelectionOption={false} // Whether to show an option for "no selection"
                                    >
                                        {getListZoneMap?.map((item, index) => {
                                            return (
                                                <MenuItem key={index} value={item.id ? item.id : 'map'}>
                                                    {item.name}
                                                </MenuItem>
                                            );
                                        })}
                                        <MenuItem value={'map'} selected>
                                            {t('map')}
                                        </MenuItem>
                                    </CustomSelectAndChildren>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        viewPlane !== 'map' &&
                        <div className={"d-flex justify-content-end gap-2 mt-3 mr-4"}>
                            {(DEV || permission?.includes(permissionObj?.WEB_ZONE_CREATE_DEVICES)) && viewPlane !== 'map' && (
                                <ButtonAction
                                    id='btn_sd_add_blueprint'
                                    name='add'
                                    className='btn-icon-add'
                                    Icon={MapSolidIcon}
                                    onClick={() => setShowPlaneModal(true)}
                                    splitName={false}
                                />

                            )}
                            {(DEV || permission?.includes(permissionObj?.WEB_ZONE_DELETE_DEVICES)) && viewPlane !== 'map' && (
                                <ButtonAction
                                    id='btn_sd_remove_blueprint'
                                    name='remove'
                                    className='btn-icon-delete'
                                    Icon={TrashOutlineIcon}
                                    onClick={() => setDeletePlaneModal(true)}
                                />
                            )}
                            {(DEV || permission?.includes(permissionObj?.WEB_ZONE_READ_DEVICES)) && viewPlane !== 'map' && (
                                <ButtonAction
                                    id='btn_sd_device_info'
                                    name='device_info'
                                    className='btn-icon-search'
                                    Icon={InfoIcon}
                                    onClick={() => {setIsDeviceList(true);}}
                                    splitName={false}
                                />
                            )}
                        </div>
                    }
                    {viewPlane === 'map' ? (
                        <div>
                            <div className={"add-btn-map"}>
                                {(DEV || permission?.includes(permissionObj?.WEB_ZONE_CREATE_DEVICES)) && (
                                    <ButtonAction
                                        id='btn_sd_add_blueprint'
                                        name='add'
                                        className='btn-icon-add'
                                        Icon={MapSolidIcon}
                                        onClick={() => setShowPlaneModal(true)}
                                        splitName={false}
                                    />

                                )}
                            </div>
                            <div>
                                <ZoneMapSelect
                                    latlng={[
                                        zoneDetailFatherAndChild?.latitud || sessionStorage.getItem('currentZoneLat'),
                                        zoneDetailFatherAndChild?.longitud || sessionStorage.getItem('currentZoneLng'),
                                    ]}
                                    className='zone_map'
                                />
                            </div>
                        </div>
                    ) : (
                        <div className='zone_plane_drag_drop_container d-flex justify-content-center mt-5rem'>
                            <ShowImg xCord={x} yCord={y} selectedZone={selectedZone}/>
                            {isDeviceList && (
                                <div className='zone_plane_device_list'>
                                    <div className='cross_container'>
                                        <i className='fa fa-times cross_zone_device' aria-hidden='true'
                                            onClick={() => {setIsDeviceList(false);}}
                                         />
                                    </div>
                                    <h4>{t('devices')}</h4>
                                    {getZoneDevicesLists?.length > 0 ? (
                                        getZoneDevicesLists?.map((item, index) => {
                                            return (
                                                <DeviceListZonePlane
                                                    item={item}
                                                    zoneplaneId={selectedZone}
                                                    index={index}
                                                />
                                            );
                                        })
                                    ) : (
                                        <Box className={"imge-nodata"}>
                                            <img src={noData} alt='' />
                                            <p>
                                                {t('no_devices')}
                                            </p>
                                        </Box>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <ShowDeviceModal
                    show={showPlaneModal}
                    onHide={() => setShowPlaneModal(false)}
                    setProfileImage={setProfileImage}
                />

                <RemovePlanModal
                    id={selectedZone?.id}
                    show={deletePlaneModal}
                    onHide={() => setDeletePlaneModal(false)}
                />
            </div>
        </>
    );
};

export default ShowDevices;
